import { ButtonInline } from '@bbc-account/id-components';
import styled from 'styled-components';

export const StyledButtonInline = styled(ButtonInline)``;
